import * as React from 'react';
import { connect } from 'react-redux';
import {Col, Form, Modal, Row} from 'react-bootstrap';
import { flow, forEach, size, isUndefined } from 'lodash';
import { IStore } from '../../../../redux/IStore';
import {IAuthActions} from '../../../../services/auth/reducer';
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import {ICompleteData, IQuoteActions} from '../../../../services/quote/models';
import {IProduct, ICustomer, IPremium, IQuotes, IPolicyApplication, IVehicle} from '../../../../data/api/models';
import { IBrandingState, II18nMessages } from '../../../../services/branding/models';
import {displayCurrency} from '../../../../util/helpers';
import * as moment from 'moment';
import FaSpinner from 'react-icons/fa/spinner';
import FaInfoCircle = require('react-icons/lib/fa/info-circle');

interface ICompleteProps extends InjectedFormProps {
  quotes: IQuotes;
  premium: IPremium;
  product: IProduct;
  renewal: boolean;
  i18n: II18nMessages;
  customer: ICustomer;
  data: ICompleteData;
  branding: IBrandingState;
  renderDefinition(name: string): any;
  actions: {
    quote: IQuoteActions;
    push(path: string);
    auth: IAuthActions;
  };
  values: any;
  application: IPolicyApplication;
}

interface ICompleteState {
  polling: boolean;
  pollId?: number;
  showVehicleModel: boolean;
  compulsoryExcessType: string;
}

class IComplete extends React.Component<ICompleteProps, ICompleteState> {
  public state = {
    polling: false,
    pollId: null,
    showVehicleModel: false,
    compulsoryExcessType: '',
  };

  public componentDidMount() {
    const { initialValues } = this.props;
    const vehicles = initialValues.vehicles;

    // Block going back
    const { history, location } = window;
    history.pushState(null, null, location.href);
    window.onpopstate = (event) => {
      event.preventDefault();
      history.go(1);
    };

    let compulsoryExcessType = 'None';
    forEach(vehicles, (horsebox) => {
      if (horsebox.coverType === 'Third Party, Fire and Theft' || horsebox.coverType === 'Fire and Theft') {
        compulsoryExcessType = 'Fire & Theft';
      }
    });
    forEach(vehicles, (horsebox) => {
      if (horsebox.coverType === 'Comprehensive') {
        compulsoryExcessType = 'Accidental Damage Fire & Theft';
      }
    });
    this.setState({compulsoryExcessType});
  }

  public componentWillUnmount() {
    if (this.state.pollId) {
      // window.clearTimeout(this.state.pollId);
    }
  }

  private showDocuments = () => {
    const { data, renewal } = this.props;

    if (! data.documents.documents) {
      return null;
    }

    const documents = [];
    const targetDocuments = [
      {
        name: renewal ? 'Horsebox Renewal Schedule' : 'Horsebox New Business Schedule',
        display: 'Schedule',
      },
      {
        name: renewal ? 'Horsebox Renewal Certificate' : 'Horsebox New Business Certificate',
        display: 'Certificate',
      },
      {
        name: 'Horsebox Statement of Fact',
        display: 'Statement of Fact',
      },
      {
        name: 'Policy Wording: Horsebox',
        display: 'Policy Wording',
      },
      {
        name: 'Policy Wording: Horsebox Breakdown',
        display: 'Horsebox Breakdown Policy Wording',
      },
      {
        name: 'IPID: Horsebox',
        display: 'Insurance Product Information Document',
      },
      {
        name: 'Terms of Business: Greenlands',
        display: 'Terms of Business',
      },
    ];
    forEach(targetDocuments, (targetDocument) => {
      if (!isUndefined(data.documents.documents[targetDocument.name])) {
        documents.push({
          displayName: targetDocument.display,
          filePath: data.documents.documents[targetDocument.name],
        });
      }
    });

    return (
      <div>
        {documents.map((document, index) => {
          return (
            <Row key={index} className={'documents'}>
              <Col sm={12}>
                <a
                  className="btn-secondary btn full-width"
                  href={document.filePath}
                  target="_blank"
                >
                  <img src={require('../../img/file_pdf_white.svg')} alt="" />{' '}{document.displayName}
                </a>
              </Col>
            </Row>
          );
        })}
      </div>
    );
  }

  private openVehicleModal = () => {
    this.setState({
      showVehicleModel: true,
    });
  }

  private closeVehicleModal = () => {
    this.setState({
      showVehicleModel: false,
    });
  }

  private renderVehicleModal = () => {
    const { initialValues } = this.props;
    const { showVehicleModel } = this.state;
    const vehicles = initialValues.vehicles;

    return (
      <Modal show={showVehicleModel} onHide={this.closeVehicleModal}>
        <Modal.Header
          closeButton={true}
          className="modal-background-black sub-content-container-alt"
          style={{ marginBottom: '0' }}
        >
          <div className="title-no-border">
            Vehicles
          </div>
        </Modal.Header>
        <Modal.Body>
          {vehicles.map((vehicle, index) => (
            <div className="complete-modal-body">
              <h3><strong>Horsebox {index + 1}</strong></h3>
              Registration Number: {vehicle.registrationNumber}<br />
              Make: {vehicle.make}<br />
              Model: {vehicle.model}<br />
              Cover: {vehicle.coverType}<br />
              Breakdown Cover: {vehicle.breakdownCover === 'true' ? 'Yes' : 'No'}<br />
            </div>
          ))}
        </Modal.Body>
      </Modal>
    );
  }

  private renderCoverInformation = () => {
    const { application, premium } = this.props;
    const { compulsoryExcessType } = this.state;

    return (
      <div className="sub-content-container">
        <div className="cover-information-row">
          Horseboxes:
          <span className="cover-information-detail">Horsebox x
            {application.vehicleCount}{' '}
            <FaInfoCircle onClick={this.openVehicleModal} />
          </span>
        </div>
        <div className="cover-information-row">
          Cover Dates:
          <span className="cover-information-detail">{application.startDate} to&nbsp;
            {moment(application.endDate).format('DD/MM/YYYY')}</span>
        </div>
        <div className="cover-information-row">
          Total Premium:
          <span className="cover-information-detail">£{displayCurrency(premium.gross, ',')}</span>
        </div>
        <Row className="row-color">
          <Col sm={4}>
            Excess:
          </Col>
            <Col sm={6}>
              Compulsory Policy Excess:<br />
              <div className="complete-sub-info">{compulsoryExcessType !== 'None' ? ('(' + compulsoryExcessType + ')')
                : ''}</div>
            </Col>
            <Col sm={2} className="position-right">
              {compulsoryExcessType !== 'None' ? ('£' + displayCurrency(application.compulsoryExcess ?
                application.compulsoryExcess : 100, ',', true)) : 'None'}
            </Col>
        </Row>
        <Row className="row-color">
          <Col sm={4} />
          <Col sm={6}>
            Voluntary Excess:<br />
          </Col>
          <Col sm={2} className="position-right">
            £{displayCurrency(application.voluntaryExcess, ',', true)}
          </Col>
        </Row>
      </div>
    );
  }

  private pollDocuments = () => {
    const { data, actions } = this.props;

    actions.quote.pollPolicyDocuments(data.documents_poll_token).then(({ documents }) => {
      if (documents.length === 0) {
        this.setState({
          pollId: window.setTimeout(this.pollDocuments, 2000),
        });

        return;
      }

      actions.quote.completeDocuments({ documents });

      this.setState({
        polling: false,
        pollId: null,
      });
    });
  }

  public componentWillMount() {
    const { data } = this.props;

    if (size(data.documents.documents) > 0) {
      return;
    }

    if (this.state.polling) {
      return;
    }

    this.setState({
      polling: true,
    });

    setTimeout(this.pollDocuments, 2000);
  }

  public render() {
    const { data } = this.props;
    const { polling } = this.state;
    const policyNumber = data.policy_number && data.policy_number;
    return (
      <Form>
        <div className="steps-container">
          <div className="sub-content-container complete-no-border">
            <h3>Payment Complete</h3>
            <p>
              Thank you for purchasing your Horsebox policy from Greenlands Insurance Services.
              <br /><br />
              You will shortly receive an email confirming your policy, and a link to create your account so you can
              access your documents online at any time.
            </p>
            <div className="policy-number-container">
              Your policy reference is: <span className="policy-number">{policyNumber}</span>
              <div className="clearfix" />
              <br />
            </div>

            <div className="complaint-container">
              <Row className="">
                <Col sm={6}>
                  <div className="sub-title">
                    <h3>Policy Summary</h3>
                  </div>
                  <p>Please find details of your cover below.</p>
                  {this.renderCoverInformation()}
                </Col>
                <Col sm={6}>
                  <div className="sub-title">
                    <h3>Documents</h3>
                  </div>
                  <p>You can download your policy documents below.</p>
                  <div className="sub-content-container-alt">
                    {polling ? <FaSpinner className="fa-spin complete-spin"/> : this.showDocuments()}
                  </div>
                </Col>
              </Row>
            </div>

            <p className="complete-final">
              <strong>Should you have any queries, wish to make a change or need to cancel your policy, please contact
              us. <br />We look forward to hearing from you.</strong></p>
          </div>
          {this.renderVehicleModal()}
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const { quotes } = state.quote;

      let premium: IPremium = null;

      const values = selector(
        state,
        'tripType',
        'schemeId',
        'quoteReference',
      );

      if (state.quote.quotes) {
        forEach(state.quote.quotes, (tripTypes, level) => {
          forEach(tripTypes, (quotedPremium: IPremium) => {
            if (!quotedPremium) {
              return null;
            }

            if (quotedPremium.scheme.id === values.schemeId) {
              premium = quotedPremium;
            }
          });
        });
      }

      return {
        quotes,
        premium,
        branding: state.branding,
        data: state.quote.complete,
        application: state.quote.application,
      };
    },
  ),
])(IComplete);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Complete/index.tsx